import type { ClientListItem } from '../types/app'
import { formatDay } from '../catalog/format'

// displayName shows a client's name the way it appears in a list row.
export function displayName(c: Pick<ClientListItem, 'first_name' | 'last_name'>): string {
  return c.last_name ? `${c.first_name} ${c.last_name}` : c.first_name
}

// visitSummary shows how many times a client has visited, and when last.
export function visitSummary(c: Pick<ClientListItem, 'visits' | 'last_visit'>): string {
  if (c.visits === 0) return 'No appointments yet'
  const visits = c.visits === 1 ? '1 appointment' : `${c.visits} appointments`
  return c.last_visit ? `${visits} · last ${formatDay(c.last_visit)}` : visits
}

// isCurrentRequest reports whether a request issued with requestToken is still
// the most recent one, given the latest token issued so far. A search, filter
// change or "Load more" tap each take a fresh token before calling the API;
// a response whose token has fallen behind is stale (something newer has
// since been requested) and must be dropped rather than applied to the list —
// otherwise a slow "Load more" can land after a filter switch and append
// clients from the old filter onto the new one.
export function isCurrentRequest(requestToken: number, latestToken: number): boolean {
  return requestToken === latestToken
}
